/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_HallwayInputs */

const cs_enum_hallway = /** @type {(inputs: Enum_HallwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chodba`)
};

const en_enum_hallway = /** @type {(inputs: Enum_HallwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallway`)
};

/**
* | output |
* | --- |
* | "Hallway" |
*
* @param {Enum_HallwayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_hallway = /** @type {((inputs?: Enum_HallwayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_HallwayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_hallway(inputs)
	return cs_enum_hallway(inputs)
});